<template>
    <div style="text-align: center" class="p-table">
        <div style="width: 87%;margin-left: 1%" >
            <div style="margin-top: 10px;font-size: 25px;font-weight: 600">安装确认表</div>
            <table style="width: 100%;margin-top: 20px;">
                <tr >
                    <!--<td >公司单号：</td>
                    <td colspan="2" >{{tableData.contract_number}}</td>-->
                    <td  colspan="2">出货单号:</td>
                    <td colspan="2" >{{tableData.order_sn}}</td>
                    <td colspan="2" >{{tableData.company_name}}</td>
                    <td colspan="3"><span style="mso-spacerun:yes"></span>安装单号：</td>
                    <td colspan="2" >{{tableData.install_sn}}</td>
                </tr>
                <tr>
                    <td colspan="4"> 项　目　地　址：</td>
                    <td colspan="7" style="text-align: left;padding-left: 20px">{{tableData.address_all}}</td>
                </tr>
                <tr>
                    <td colspan="2">收货人 ：</td>
                    <td colspan="2" >{{tableData.consignee}}</td>
                    <td colspan="2" >联系方式</td>
                    <td colspan="2" >{{tableData.mobile}}</td>
                    <td colspan="2" >销售单位</td>
                    <td colspan="1" >{{tableData.store_name}}</td>
                </tr>
                <tr>
                    <td colspan="3">客户要求安装时间： </td>
                    <td colspan="3">{{tableData.yuyue_time}}</td>
                    <td colspan="2">安 装 人 员:</td>
                    <td colspan="3">{{tableData.team_name}}</td>
                </tr>
                <tr >
                    <td colspan="3" >已备货/提货情 况：</td>
                    <td colspan="5" ></td>
                    <td colspan="3">安装前一天务必联系上客户</td>
                </tr>
                <tr >
                    <td >序号</td>
                    <td colspan="4">型号</td>
                    <td colspan="3">数量（台）</td>
                    <td colspan="3">备注</td>
                </tr>
                <tr >
                    <td>1</td>
                    <td colspan="4" >{{tableData.order_goods[0].goods_attr_select[0]===undefined?tableData.order_goods[0].goods_attr:tableData.order_goods[0].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[0].goods_number}}</td>
                    <td colspan="5" >1.备铜管　　<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>是　　<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>否</td>
                </tr>
                <tr >
                    <td>2</td>
                    <td colspan="4" >{{tableData.order_goods[1]===undefined?'':tableData.order_goods[1].goods_attr_select[0]===undefined?tableData.order_goods[1].goods_attr:tableData.order_goods[1].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[1]===undefined?'':tableData.order_goods[1].goods_number}}</td>
                    <td colspan="5" >2.远程费（<input style="width: 50px;text-align: center"/>元）<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>销售单位结算 　<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>向用户收取</td>
                </tr>
                <tr >
                    <td>3</td>
                    <td colspan="4" >{{tableData.order_goods[2]===undefined?'':tableData.order_goods[2].goods_attr_select[0]===undefined?tableData.order_goods[2].goods_attr:tableData.order_goods[2].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[2]===undefined?'':tableData.order_goods[2].goods_number}}</td>
                    <td colspan="5">3.高空费/难度费（<input style="width: 50px;text-align: center"/>元）<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>销售单位结算　<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>向用户收取；</td>
                </tr>
                <tr >
                    <td>4</td>
                    <td colspan="4" >{{tableData.order_goods[3]===undefined?'':tableData.order_goods[3].goods_attr_select[0]===undefined?tableData.order_goods[3].goods_attr:tableData.order_goods[3].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[3]===undefined?'':tableData.order_goods[3].goods_number}}</td>
                    <td colspan="5">4.水钻孔（<input style="width: 50px;text-align: center"/>元）<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>销售单位结算　<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>向用户收取；</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td colspan="4" >{{tableData.order_goods[4]===undefined?'':tableData.order_goods[4].goods_attr_select[0]===undefined?tableData.order_goods[4].goods_attr:tableData.order_goods[4].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[4]===undefined?'':tableData.order_goods[4].goods_number}}</td>
                    <td colspan="5">5.材料费/其它费用（<input style="width: 50px;text-align: center"/>元）<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>销售单位结算　<input type="checkbox" style="width: 20px;height: 15px;background-color:#fff;"/>向用户收取；</td>
                </tr>
                <tr >
                    <td >6</td>
                    <td colspan="4" >{{tableData.order_goods[5]===undefined?'':tableData.order_goods[5].goods_attr_select[0]===undefined?tableData.order_goods[5].goods_attr:tableData.order_goods[5].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[5]===undefined?'':tableData.order_goods[5].goods_number}}</td>
                    <td colspan="5" >附加：请今晚联系好客户</td>
                </tr>
                <tr v-if="tableData.order_goods.length>6" >
                    <td >7</td>
                    <td colspan="4" >{{tableData.order_goods[6]===undefined?'':tableData.order_goods[6].goods_attr_select[0]===undefined?tableData.order_goods[6].goods_attr:tableData.order_goods[6].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[6]===undefined?'':tableData.order_goods[6].goods_number}}</td>
                    <td colspan="5" ></td>
                </tr>
                <tr v-if="tableData.order_goods.length>7" >
                    <td >8</td>
                    <td colspan="4" >{{tableData.order_goods[7]===undefined?'':tableData.order_goods[7].goods_attr_select[0]===undefined?tableData.order_goods[7].goods_attr:tableData.order_goods[7].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[7]===undefined?'':tableData.order_goods[7].goods_number}}</td>
                    <td colspan="5" ></td>
                </tr>
                <tr v-if="tableData.order_goods.length>8" >
                    <td >9</td>
                    <td colspan="4" >{{tableData.order_goods[8]===undefined?'':tableData.order_goods[8].goods_attr_select[0]===undefined?tableData.order_goods[8].goods_attr:tableData.order_goods[8].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[8]===undefined?'':tableData.order_goods[8].goods_number}}</td>
                    <td colspan="5" ></td>
                </tr>
                <tr v-if="tableData.order_goods.length>9" >
                    <td >10</td>
                    <td colspan="4" >{{tableData.order_goods[9]===undefined?'':tableData.order_goods[9].goods_attr_select[0]===undefined?tableData.order_goods[9].goods_attr:tableData.order_goods[9].goods_attr_select[0]}}</td>
                    <td colspan="1" >{{tableData.order_goods[9]===undefined?'':tableData.order_goods[9].goods_number}}</td>
                    <td colspan="5" ></td>
                </tr>
                <tr >
                    <td  colspan="3"> 备注：</td>
                    <td  colspan="8" style="text-align: left; padding-left: 20px;">{{tableData.remark}}</td>
                </tr>
                <tr >
                    <td  colspan="3"> 公司备注：</td>
                    <td  colspan="8" style="text-align: left; padding-left: 20px;">{{tableData.company_remark}}</td>
                </tr>
                <tr >
                    <td rowspan="2" >销售方</td>
                    <td colspan="2" >联系人</td>
                    <td colspan="2" ></td>
                    <td colspan="3" >签单业务</td>
                    <td colspan="3" ></td>
                </tr>
                <tr>
                    <td colspan="2" >联系电话</td>
                    <td colspan="2">36243906</td>
                    <td colspan="3">传真</td>
                    <td colspan="3" >86187706</td>
                </tr>
                <tr style="font-weight: 600;border: 0;text-align: left;height: 60px" >
                    <td colspan="8" style="font-weight: 600;border: 0;text-align: left" >请对上述内容签名确认 业主（或业主指定人）:</td>
                    <td colspan="2" style="font-weight: 600;border: 0;text-align: left" >安装人员:</td>
                    <td colspan="1" style="font-weight: 600;border: 0;text-align: left" >安装日期:</td>
                </tr>
            </table>
        </div>

    </div>
</template>
<script>
   export default {
       data() {
           return {
               tableData: JSON.parse(localStorage.getItem('installData')),
               data: [],
           }
       },
       filters: {
         formatters(val) {

         }
       },
       created() {
           this.$http.get(this.$reqUrl + `service.php?act=install_print&install_id=${this.tableData.install_id}`).then(res => {
               // this.data.res.data.list
           })
       },
       mounted() {
           window.print()
       }
   }
</script>
<style lang="less" scoped>
    body{
        height: auto;
    }
.p-table{
    font-size:21px;
    table,table tr th, table tr td { border:1px solid #000000; }
    table{
        text-align: center; border-collapse: collapse;line-height:30px;
        input{
            border: 0px;
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/router/Printing1.vue